/**
 * landing.js — Split-screen division chooser (Cannabis / Wellness)
 * Ported from the Horizon prototype to the live Moxie theme.
 *
 * STATES (CSS classes on #splitScreen):
 *   (none)               → 50/50 default split
 *   .is-hover-cannabis   → Left panel expanded
 *   .is-hover-wellness   → Right panel expanded
 *   .is-clicked-cannabis → Left panel 100%, then navigate to /?view=cannabis
 *   .is-clicked-wellness → Right panel 100%, then navigate to /?view=wellness
 */

(function () {
  'use strict';

  var splitScreen = document.getElementById('splitScreen');
  var panelCannabis = document.getElementById('panelCannabis');
  var panelWellness = document.getElementById('panelWellness');

  if (!splitScreen || !panelCannabis || !panelWellness) return;

  var isClicked = false;
  var isMobile = window.matchMedia('(max-width: 768px)').matches;
  var hasHover = window.matchMedia('(hover: hover)').matches;

  // On desktop the wellness image-wrapper is pulled left by the cannabis
  // panel's current width so both images align to the viewport's left edge
  // (this is what makes the sliding-reveal illusion work).
  var wellnessImageWrapper = panelWellness.querySelector('.split-screen__image-wrapper');
  var rafId = null;

  function updateWellnessOffset() {
    if (isMobile || !wellnessImageWrapper) return;
    var cannabisWidth = panelCannabis.getBoundingClientRect().width;
    wellnessImageWrapper.style.left = '-' + cannabisWidth + 'px';
  }

  function trackTransition() {
    updateWellnessOffset();
    rafId = requestAnimationFrame(trackTransition);
  }

  function startTracking() {
    if (rafId) cancelAnimationFrame(rafId);
    trackTransition();
  }

  function stopTracking() {
    if (rafId) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
    updateWellnessOffset();
  }

  function onPanelEnter(side) {
    if (isClicked || isMobile || !hasHover) return;
    splitScreen.classList.remove('is-hover-cannabis', 'is-hover-wellness');
    splitScreen.classList.add('is-hover-' + side);
    startTracking();
  }

  function onPanelLeave() {
    if (isClicked || isMobile || !hasHover) return;
    splitScreen.classList.remove('is-hover-cannabis', 'is-hover-wellness');
    startTracking();
  }

  function onPanelClick(side) {
    if (isClicked) return;
    isClicked = true;

    var panel = side === 'cannabis' ? panelCannabis : panelWellness;
    var targetLayout = panel.getAttribute('data-target');

    splitScreen.classList.remove('is-hover-cannabis', 'is-hover-wellness');
    splitScreen.classList.add('is-clicked-' + side);
    startTracking();

    try { localStorage.setItem('HomeLayout', targetLayout); } catch (e) {}

    // Navigate after the CSS transition completes (~800ms + buffer)
    setTimeout(function () {
      document.documentElement.setAttribute('data-layout', targetLayout);
      if (side === 'cannabis') window.location.href = '/?view=cannabis';
      if (side === 'wellness') window.location.href = '/?view=wellness';
    }, 850);
  }

  panelCannabis.addEventListener('mouseenter', function () { onPanelEnter('cannabis'); });
  panelCannabis.addEventListener('mouseleave', onPanelLeave);
  panelCannabis.addEventListener('click', function () { onPanelClick('cannabis'); });

  panelWellness.addEventListener('mouseenter', function () { onPanelEnter('wellness'); });
  panelWellness.addEventListener('mouseleave', onPanelLeave);
  panelWellness.addEventListener('click', function () { onPanelClick('wellness'); });

  splitScreen.addEventListener('transitionend', function (e) {
    if (e.propertyName === 'flex-basis') stopTracking();
  });

  var mqMobile = window.matchMedia('(max-width: 768px)');
  mqMobile.addEventListener('change', function (e) {
    isMobile = e.matches;
    if (isMobile) {
      splitScreen.classList.remove('is-hover-cannabis', 'is-hover-wellness');
      if (wellnessImageWrapper) wellnessImageWrapper.style.left = '0';
    } else {
      updateWellnessOffset();
    }
  });

  var mqHover = window.matchMedia('(hover: hover)');
  mqHover.addEventListener('change', function (e) { hasHover = e.matches; });

  updateWellnessOffset();
  window.addEventListener('resize', updateWellnessOffset);
})();
